import { Typography } from '@mui/material';

import { LabeledText, LabeledTextSize } from 'components/text/LabeledText';

export type DecimalTextProps = {
    value: number;
    prefix?: string;
    suffix?: string;
    label?: string;
    color?: string;
    size?: LabeledTextSize;
};

const innerSizes: Record<LabeledTextSize, { affix: number; integer: number; decimal: number }> = {
    xs: { affix: 8, integer: 13, decimal: 9 },
    sm: { affix: 11, integer: 16, decimal: 10 },
    md: { affix: 14, integer: 18, decimal: 11 },
    lg: { affix: 16, integer: 28, decimal: 13 },
};

export function DecimalText({ value, prefix, suffix, label, color, size = 'md' }: DecimalTextProps) {
    const s = innerSizes[size];
    const formatted = value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const [intPart, decPart] = formatted.split(',');

    return (
        <LabeledText
            label={label}
            color={color}
            size={size}
            value={
                <>
                    {prefix && (
                        <Typography component="span" sx={{ fontSize: s.affix, fontWeight: 500, color: 'text.disabled', lineHeight: 1, mr: 0.4 }}>
                            {prefix}
                        </Typography>
                    )}

                    <Typography
                        component="span"
                        sx={{
                            fontSize: s.integer,
                            fontWeight: size === 'xs' ? 500 : 600,
                            color: color || 'text.primary',
                            lineHeight: 0.85,
                        }}
                    >
                        {intPart}
                    </Typography>

                    <Typography
                        component="span"
                        sx={{
                            fontSize: s.decimal,
                            fontWeight: 500,
                            color: color || 'text.primary',
                            lineHeight: 1,
                            alignSelf: suffix ? 'flex-end' : 'flex-start',
                        }}
                    >
                        ,{decPart}
                    </Typography>

                    {suffix && (
                        <Typography component="span" sx={{ fontSize: s.affix, fontWeight: 500, color: 'text.disabled', lineHeight: 1, ml: 0.4 }}>
                            {suffix}
                        </Typography>
                    )}
                </>
            }
        />
    );
}
